(function () {
  var cfg = window.GridHive || {};
  var STORAGE_GUEST = 'gh_wishlist_guest';

  function storageKey() {
    if (cfg.customer && cfg.customer.id) return 'gh_wishlist_' + cfg.customer.id;
    return STORAGE_GUEST;
  }

  function readList() {
    try {
      var raw = localStorage.getItem(storageKey());
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    localStorage.setItem(storageKey(), JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('gh:wishlist:change', { detail: { items: list } }));
  }

  function isLoggedIn() {
    return !!(cfg.customer && cfg.customer.id);
  }

  function loginUrl(returnTo) {
    var base = (cfg.routes && cfg.routes.login) || '/account/login';
    var ret = returnTo || window.location.pathname + window.location.search;
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(ret);
  }

  function requireLogin(returnTo) {
    window.location.href = loginUrl(returnTo);
  }

  function migrateGuestWishlist() {
    if (!isLoggedIn()) return;
    try {
      var guest = JSON.parse(localStorage.getItem(STORAGE_GUEST) || '[]');
      if (!Array.isArray(guest) || !guest.length) return;
      var current = readList();
      var merged = current.slice();
      guest.forEach(function (handle) {
        if (merged.indexOf(handle) === -1) merged.push(handle);
      });
      writeList(merged);
      localStorage.removeItem(STORAGE_GUEST);
    } catch (e) {}
  }

  function has(handle) {
    return readList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return null;
    if (!isLoggedIn()) {
      try {
        sessionStorage.setItem('gh_wishlist_pending', handle);
      } catch (e) {}
      requireLogin();
      return null;
    }
    var list = readList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
      writeList(list);
      return true;
    }
    list.splice(idx, 1);
    writeList(list);
    return false;
  }

  function applyPendingWishlist() {
    if (!isLoggedIn()) return;
    try {
      var pending = sessionStorage.getItem('gh_wishlist_pending');
      if (!pending) return;
      sessionStorage.removeItem('gh_wishlist_pending');
      if (!has(pending)) {
        var list = readList();
        list.push(pending);
        writeList(list);
      }
    } catch (e) {}
  }

  function remove(handle) {
    if (!isLoggedIn()) return;
    writeList(
      readList().filter(function (h) {
        return h !== handle;
      })
    );
  }

  function syncButtons(root) {
    var scope = root || document;
    var list = readList();
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = !!(handle && list.indexOf(handle) !== -1);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateBadges() {
    var count = isLoggedIn() ? readList().length : 0;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function imageUrl(product) {
    var src = product.featured_image || (product.images && product.images[0]) || '';
    if (!src) return '';
    if (src.indexOf('http') === 0) {
      return src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_400x$1$2');
    }
    return src;
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var gate = root.querySelector('[data-wishlist-gate]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var grid = root.querySelector('[data-wishlist-grid]');
    var countEl = root.querySelector('[data-wishlist-page-count]');

    if (!isLoggedIn()) {
      if (gate) gate.hidden = false;
      if (empty) empty.hidden = true;
      if (grid) grid.hidden = true;
      return;
    }

    if (gate) gate.hidden = true;
    var items = readList();
    if (countEl) countEl.textContent = items.length + ' ' + (root.dataset.itemsLabel || 'items');

    if (!items.length) {
      if (empty) empty.hidden = false;
      if (grid) {
        grid.hidden = true;
        grid.innerHTML = '';
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (!grid) return;
    grid.hidden = false;
    grid.innerHTML = '<p class="gh-wish__empty-text">' + (root.dataset.loadingLabel || 'Loading…') + '</p>';

    Promise.all(
      items.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('missing');
            return r.json();
          })
          .then(function (p) {
            return { handle: handle, product: p };
          })
          .catch(function () {
            return { handle: handle, product: null };
          });
      })
    ).then(function (rows) {
      var html = '';
      var valid = 0;
      rows.forEach(function (row) {
        if (!row.product) {
          remove(row.handle);
          return;
        }
        valid += 1;
        var p = row.product;
        var img = imageUrl(p);
        var variant = (p.variants && p.variants[0]) || {};
        var available = !!variant.available;
        html +=
          '<article class="gh-wish__card" data-wish-handle="' +
          p.handle +
          '">' +
          '<button type="button" class="gh-wish__remove" data-wishlist-remove data-product-handle="' +
          p.handle +
          '" aria-label="Remove">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<a class="gh-wish__media" href="/products/' +
          p.handle +
          '">' +
          (img ? '<img src="' + img + '" alt="" width="280" height="280" loading="lazy">' : '') +
          '</a>' +
          (p.vendor ? '<p class="gh-wish__vendor">' + p.vendor + '</p>' : '') +
          '<h3 class="gh-wish__name"><a href="/products/' +
          p.handle +
          '">' +
          p.title +
          '</a></h3>' +
          '<p class="gh-wish__price">' +
          money(p.price) +
          '</p>' +
          '<button type="button" class="gh-wish__add" data-wishlist-add-cart data-variant-id="' +
          variant.id +
          '"' +
          (available ? '' : ' disabled') +
          '>' +
          (available ? root.dataset.addLabel || 'Add to cart' : root.dataset.soldLabel || 'Sold out') +
          '</button>' +
          '</article>';
      });

      if (countEl) countEl.textContent = valid + ' ' + (root.dataset.itemsLabel || 'items');
      if (!valid) {
        grid.hidden = true;
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        updateBadges();
        return;
      }
      grid.innerHTML = html;
      updateBadges();
    });
  }

  document.addEventListener('click', function (event) {
    var wishBtn = event.target.closest('[data-wishlist-toggle]');
    if (wishBtn) {
      event.preventDefault();
      var handle = wishBtn.getAttribute('data-product-handle');
      var result = toggle(handle);
      if (result === null) return;
      syncButtons();
      updateBadges();
      return;
    }

    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      remove(removeBtn.getAttribute('data-product-handle'));
      syncButtons();
      updateBadges();
      renderWishlistPage();
      return;
    }

    var addBtn = event.target.closest('[data-wishlist-add-cart]');
    if (addBtn) {
      event.preventDefault();
      var id = addBtn.getAttribute('data-variant-id');
      if (!id) return;
      addBtn.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = (cfg.routes && cfg.routes.cart) || '/cart';
        })
        .catch(function () {
          addBtn.disabled = false;
        });
    }
  });

  window.GridHiveWishlist = {
    has: has,
    toggle: toggle,
    remove: remove,
    list: readList,
    requireLogin: requireLogin,
    loginUrl: loginUrl,
    isLoggedIn: isLoggedIn,
    syncButtons: syncButtons,
    updateBadges: updateBadges,
    renderPage: renderWishlistPage
  };

  function boot() {
    migrateGuestWishlist();
    applyPendingWishlist();
    syncButtons();
    updateBadges();
    renderWishlistPage();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('gh:wishlist:change', function () {
    syncButtons();
    updateBadges();
  });
})();
